import { render } from "./tags-input.vue?vue&type=template&id=383252a6&scoped=true"
import script from "./tags-input.vue?vue&type=script&setup=true&lang=js"
export * from "./tags-input.vue?vue&type=script&setup=true&lang=js"

import "./tags-input.vue?vue&type=style&index=0&id=383252a6&lang=scss&scoped=true"
import "./tags-input.vue?vue&type=style&index=1&id=383252a6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383252a6"],['__file',"resources/js/v2/components/form/tags-input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "383252a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('383252a6', __exports__)) {
    console.log('reload')
    api.reload('383252a6', __exports__)
  }
  
  module.hot.accept("./tags-input.vue?vue&type=template&id=383252a6&scoped=true", () => {
    console.log('re-render')
    api.rerender('383252a6', render)
  })

}


export default __exports__